import "jquery";
import "slick-carousel";